
import { useEffect, useState } from 'react';
import { generateMockData } from '@/components/dashboard/stats/mockDataUtils';
import { TrackDownload } from '@/lib/types';

export const useMockData = (uploads: TrackDownload[], isLoading: boolean) => {
  const [mockUploads, setMockUploads] = useState<TrackDownload[]>([]);
  const [useMockData, setUseMockData] = useState(false);
  
  useEffect(() => {
    if (!isLoading) {
      const hasRealData = uploads.length > 0 && uploads.some(upload => upload.downloadCount > 0);
      
      if (!hasRealData) {
        const mockData = generateMockData();
        setMockUploads(mockData);
        setUseMockData(true);
      } else {
        setUseMockData(false);
      }
    }
  }, [uploads, isLoading]);
  
  return {
    mockUploads,
    setMockUploads,
    useMockData,
    setUseMockData
  };
};
